export default [
  {
    path: '/updateUserInfo', // 添加保险卡、手机绑定保险卡
    name: 'updateUserInfo',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/updateUserInfo.vue'
      )
    }
  },
  {
    path: '/addChildBXCard', // 添加保险卡、手机绑定保险卡
    name: 'addChildBXCard',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/AddChildBXCard.vue'
      )
    }
  },
  {
    path: '/zjd/BXCard', // 保险卡
    name: 'BXCard',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/BXCard.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zjd/BXCardManage', // 保险卡管理
    name: 'BXCardManage',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/BXCardManage.vue'
      )
    }
  },
  {
    path: '/zjd/customCard', // 编辑背景
    name: 'customCard',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/CustomCard.vue'
      )
    }
  },
  {
    path: '/zjd/SeeSendInfo', // 查看寄送信息
    name: 'seeSendInfo',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/SeeSendInfo.vue'
      )
    }
  },
  {
    path: '/zjd/supplementary', // 补充材料
    name: 'supplementary',
    component: () => {
      return import(
        /* webpackChunkName: "bxcard" */ '@/views/bxcard/Supplementary.vue'
      )
    }
  }
]
